<app-base-grid-template [gridTitle]="gridTitle" [showAddButton]="false" (addButtonClick)="onAddButtonClicked()" (filterTextChange)="onFilterTextChanged($event)" (resetGridClick)="onResetGridClicked()" (exportGridClick)="onExportGridClicked()">
  <app-base-grid-content-template>
    <div class="subtle-text">
      {{description}}
    </div>
    <ag-grid-angular *ngIf="gridOptions"
                     class="ag-theme-alpine"
                     [gridOptions]="gridOptions">
    </ag-grid-angular>
  </app-base-grid-content-template>
</app-base-grid-template>



